import React, { useState, useRef, useEffect } from 'react';

const EMOJI_CATEGORIES = [
    {
        icon: '😀',
        label: 'Smileys',
        emojis: [
            '😀',
            '😃',
            '😄',
            '😁',
            '😆',
            '😅',
            '🤣',
            '😂',
            '🙂',
            '😊',
            '😇',
            '🥰',
            '😍',
            '🤩',
            '😘',
            '😗',
            '😚',
            '😙',
            '🥲',
            '😋',
            '😛',
            '😜',
            '🤪',
            '😝',
            '🤑',
            '🤗',
            '🤭',
            '🤫',
            '🤔',
            '🫡',
            '🤐',
            '🤨',
            '😐',
            '😑',
            '😶',
            '🫥',
            '😏',
            '😒',
            '🙄',
            '😬',
            '😮‍💨',
            '🤥',
            '😌',
            '😔',
            '😪',
            '🤤',
            '😴',
            '😷',
            '🤒',
            '🤕',
            '🤢',
            '🤮',
            '🥴',
            '😵',
            '🤯',
            '🥳',
            '🥸',
            '😎',
            '🤓',
            '🧐',
        ],
    },
    {
        icon: '👋',
        label: 'Gestures',
        emojis: [
            '👋',
            '🤚',
            '🖐️',
            '✋',
            '🖖',
            '🫱',
            '🫲',
            '🫳',
            '🫴',
            '👌',
            '🤌',
            '🤏',
            '✌️',
            '🤞',
            '🫰',
            '🤟',
            '🤘',
            '🤙',
            '👈',
            '👉',
            '👆',
            '🖕',
            '👇',
            '☝️',
            '🫵',
            '👍',
            '👎',
            '✊',
            '👊',
            '🤛',
            '🤜',
            '👏',
            '🙌',
            '🫶',
            '👐',
            '🤲',
            '🤝',
            '🙏',
            '💪',
            '🦾',
        ],
    },
    {
        icon: '❤️',
        label: 'Hearts',
        emojis: [
            '❤️',
            '🧡',
            '💛',
            '💚',
            '💙',
            '💜',
            '🖤',
            '🤍',
            '🤎',
            '💔',
            '❤️‍🔥',
            '❤️‍🩹',
            '❣️',
            '💕',
            '💞',
            '💓',
            '💗',
            '💖',
            '💘',
            '💝',
            '💟',
            '♥️',
            '💯',
            '💢',
            '💥',
            '💫',
            '💦',
            '💨',
            '🕳️',
            '💤',
        ],
    },
    {
        icon: '🎉',
        label: 'Objects',
        emojis: [
            '🎉',
            '🎊',
            '🎈',
            '🎁',
            '🏆',
            '🥇',
            '🥈',
            '🥉',
            '⭐',
            '🌟',
            '💡',
            '🔥',
            '✨',
            '🎯',
            '💎',
            '🔔',
            '📌',
            '📎',
            '✅',
            '❌',
            '⚠️',
            '🚀',
            '💻',
            '📱',
            '📧',
            '📝',
            '📅',
            '🗂️',
            '📊',
            '📈',
        ],
    },
];

export const EmojiPicker = ({ onSelect, onClose }) => {
    const [activeCategory, setActiveCategory] = useState(0);
    const pickerRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (pickerRef.current && !pickerRef.current.contains(e.target)) {
                onClose();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [onClose]);

    return (
        <div className="chat-emoji-picker-container" ref={pickerRef}>
            <div className="chat-emoji-picker-header">
                {EMOJI_CATEGORIES.map((cat, idx) => (
                    <button
                        key={cat.label}
                        className={`chat-emoji-category-btn ${activeCategory === idx ? 'chat-emoji-category-btn-active' : ''}`}
                        onClick={() => setActiveCategory(idx)}
                        title={cat.label}
                        type="button"
                    >
                        {cat.icon}
                    </button>
                ))}
            </div>
            <div className="chat-emoji-grid">
                {EMOJI_CATEGORIES[activeCategory].emojis.map((emoji) => (
                    <button key={emoji} className="chat-emoji-btn" onClick={() => onSelect(emoji)} type="button">
                        {emoji}
                    </button>
                ))}
            </div>
        </div>
    );
};
